

document.addEventListener('DOMContentLoaded', () => {
  // Disable animations in Shopify editor
  if (Shopify && Shopify.designMode) {
    document.querySelectorAll('[data-animate], .animate').forEach(el => {
      el.classList.add('is-visible');
    });
    return;
  }

  const animatedElements = document.querySelectorAll('[data-animate], .animate');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  animatedElements.forEach(el => observer.observe(el));
});
